import src from "IMAGE";
export default { src, width: 191, height: 139, blurWidth: 0, blurHeight: 0};
